<div class="users-filter" data-test-id="account-manage-filter">
  <app-heading titleLevel="3" spacingBottom="16">
    {{ 'account.manageTabTitle' | translate }}
  </app-heading>
  <app-text-input
    id="searchText"
    [type]="InputType.SEARCH"
    [size]="InputSize.SMALL"
    [(value)]="searchInput"
    [disabled]="isLoading()"
    placeholder="{{ 'common.search' | translate }}"
    data-test-id="account-manage-search-input"
  />
</div>
<div class="users-container">
  @if (isLoading()) {
  <app-spinner data-test-id="account-manage-spinner"></app-spinner>
  } @else {
  <app-table
    [tableData]="filteredUsers()"
    [config]="tableConfig"
    (handleOptionSelected)="onAction($event)"
    data-test-id="account-manage-table"
  ></app-table>
  @if (!adminUsers().length) {
  <p>
    {{ 'common.noAdmin' | translate }}
  </p>
  } }
</div>
<app-confirm-dialog
  [(isOpen)]="openDialog"
  (handlePrimaryButton)="onRemove()"
  (handleSecondaryButton)="onCloseDialog()"
  [title]="
    'account.removeDialogText' | translate : { name: selectedItem?.name || '' }
  "
  [primaryText]="'account.removeDialogConfirmLabel' | translate"
  [secondaryText]="'account.removeDialogCancelLabel' | translate"
  [titleAlignment]="TextAlign.CENTER"
  [headerGap]="Spacing.NONE"
  data-test-id="account-manage-confirm-dialog"
>
</app-confirm-dialog>
